import React from 'react';
import styles from './style.module.css';
import StepTwoForm from '../../components/forms/step-two';

export default () => (
    <div className={styles.page}>
        <p className={styles.topTitle}>Loan Intro Title</p>
        <h1 className={styles.mainTitle}>Amount to borrow</h1>
        <p className={styles.text}>Content relating to amount to borrow.</p>
        <StepTwoForm />
    </div>
);
